import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CurrentBillService {
  constructor(private http: HttpClient) {}

  getCurrentBill(policyNumber) {
    const url = `${environment.backend_server_url_billing}/${policyNumber}/currentbill`;
    return this.http.get(url);
  }
}
